import * as types from 'constants/ActionTypes';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case types.PLACE_ORDER_SUCCESS: return action.placeOrderResponse;
    case types.RESET_ORDER_SUBMITTED: return {};
    default: return state;
  }
};
